export default "/images/02a1abe33c05b8175a9ad484420c9530.avif";